import React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './reservationCompletePane.module.scss';
import { ReservationPane } from '../../atoms/reservations/ReservationPane';
import { CancellationPolicy } from './CancellationPolicy';
import { isMulticreatorSession } from '../../organisms/mypage/ReservationListPane';
import { Reservable } from '../../../../commonv3/types/reservable';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes/index';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reservable: Reservable;
};

export class ReservationCompletePane extends React.Component<Props> {
  render() {
    const { reservable } = this.props;
    return (
      <ReservationPane id="complete-session-reservation-pane" styleName="pane">
        <div styleName="text">予約が完了しました</div>
        <div styleName="date">
          マイページの「予約の確認」から{GlobalStatesV3.viewport.isSp && <br />}予約内容を確認できます
        </div>
        {!isMulticreatorSession(reservable) && <CancellationPolicy />}
        <div styleName="button-wrapper">
          <Button
            styleName="button"
            type="primary"
            size="m"
            disabled={false}
            onClick={() => GlobalStatesV3.routing.push(V3Routes.reservations())}
          >
            予約一覧を確認する
          </Button>
        </div>
      </ReservationPane>
    );
  }
}
